import {Injectable} from '@angular/core';
import {AuthServicesService} from 'mclane-webauth-lib';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';

@Injectable({
    providedIn: 'root'
})
export class KeycloakHelper {
    constructor(public _applicationSettingsHelper: ApplicationSettingsHelper, public _authService: AuthServicesService) {
    }

    getUsername(): string {
        return this._authService.getUsername().toUpperCase();
    }

    setKeycloakIsLoggingOut(value: boolean) {

    }

    getKeycloakService() {
        return this._authService;
    }

    async keycloakLogout(url: string) {
        await this._authService.logout(url);
    }

    async keycloakLogin() {

    }

    getKeycloakInstanceClientId() {
        return this._authService._keycloakService.getKeycloakInstance().clientId;
    }

    clearToken() {
        return this._authService._keycloakService.clearToken();
    }
}
